<template>
  <div v-if="terms" class="term-detail">
    <div class="term-detail__container">
      <h3 class="mb-3">{{ terms.title }}</h3>
      <div
        class="term-detail__content"
        v-if="terms.content"
        v-html="terms.content"
      ></div>
      <img class="img" v-else-if="terms.image" :src="terms.image" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      terms: null,
      selectedDate: null,
    }
  },
  async created() {
    // 번개입금 서비스 약관인 경우
    if (this.$route.params.code === 'SERVICE1') {
      const { additionalTerms } = await import('@/components/signup/agreements/terms')
      const terms = additionalTerms.find((e) => e.code === 'SERVICE1')
      this.terms = { ...terms, content: terms.content }
      return
    }

    const { date } = this.$route.query
    this.getTermsDetail(date)
  },
  methods: {
    ...mapActions('agreement', ['getTermsContentByCode']),
    async getTermsDetail(date) {
      const { code } = this.$route.params
      this.terms = await this.getTermsContentByCode({
        code,
        date,
      })
      // this.selectedDate = date ? date : this.terms.history[0]

      if (this.terms && this.terms.content) {
        this.terms.content = this.terms.content.replace(/\r\n/g, '<br>');
      }

      console.log('!!!!!')
    },
    changeDate(date) {
      this.$router.push({ query: { date } })
    },
  },
}
</script>
<style lang="scss" scoped>
.term-detail {
  &__container {
    h3 {
      text-align: center;
    }

    div.term-detail__content {
      overflow-wrap: break-word;
      p,
      span,
      table {
        line-height: 2rem;
      }
      table {
        margin: 5px 0;
      }
    }

    .histories {
      text-align: right;
      select {
        margin: 15px auto;
        border: solid 1px #d7e1ea;
        min-width: 160px;
        color: #66717f;
        font-size: 16px;
        font-weight: 700;
        height: 42px;
        text-align: center;
        text-align-last: center;
        background: url('../../assets/images/icons/btn-input-down.svg') no-repeat;
        background-position: right;
        padding-right: 10%;

        option:checked {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
